import type { AutocompleteMapOptionToListNode } from '@property.com.au/ui-kit';
import { LocationMd, P, Strong, paletteHelper, spacingHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import type { Option } from '../subcomponents/PointOfInterestSuggest/PointOfInterestSuggest';

const ListItem = styled.li<{ $isActive: boolean }>`
  background-color: ${(props) => props.$isActive && paletteHelper('backgroundSecondaryBase')};
`;

const OptionContainer = styled.div`
  margin-left: ${spacingHelper('medium')};
  margin-right: ${spacingHelper('medium')};
  padding-top: ${spacingHelper('extraSmall')};
  padding-bottom: ${spacingHelper('extraSmall')};
  display: flex;
  align-items: center;
  gap: ${spacingHelper('medium')};
`;

const Subtitle = styled(P)`
  color: ${paletteHelper('textSecondary')};
  font-size: 0.75rem;
  text-transform: capitalize;
`;

export const mapAutocompleteOptionToPointOfInterestSuggestListNode: AutocompleteMapOptionToListNode<
  Option
> = ({ option, isActive, inputValue, mapOptionToString }) => {
  const optionValue = mapOptionToString(option);
  const textToHighlight = inputValue || '';
  const inputStart = optionValue.toLowerCase().indexOf(textToHighlight.toLowerCase());
  const inputEnd = inputStart + textToHighlight.length;
  const containsInputValue = inputValue && inputStart !== -1;
  return (
    <ListItem $isActive={isActive}>
      <OptionContainer>
        <div>
          <LocationMd title="poi-suggestion" />
        </div>
        <div>
          <div>
            {containsInputValue ? (
              <P>
                {optionValue.substring(0, inputStart)}
                <Strong>{optionValue.substring(inputStart, inputEnd)}</Strong>
                {optionValue.substring(inputEnd)}
              </P>
            ) : (
              <P>{optionValue}</P>
            )}
          </div>
          <Subtitle
            title={option.suggestionType === 'address' ? 'address-subtitle' : 'place-subtitle'}
          >
            {option.suggestionType}
          </Subtitle>
        </div>
      </OptionContainer>
    </ListItem>
  );
};
